import { render, staticRenderFns } from "./LmsFriends.vue?vue&type=template&id=401e4d84&scoped=true"
import script from "./LmsFriends.vue?vue&type=script&lang=js"
export * from "./LmsFriends.vue?vue&type=script&lang=js"
import style0 from "./LmsFriends.vue?vue&type=style&index=0&id=401e4d84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401e4d84",
  null
  
)

export default component.exports